(function () {
  // ===============================
  // Guard: verhindert Doppler / Doppel-Init
  // ===============================
  if (window.__ksQuickAddInit) return;
  window.__ksQuickAddInit = true;

  const root = document.getElementById("ks-quickadd-root");
  if (!root) return;

  const backdropCloseEls = root.querySelectorAll("[data-ks-qa-close]");

  const elImg = document.getElementById("ks-qa-img");
  const elName = document.getElementById("ks-qa-name");
  const elPrice = document.getElementById("ks-qa-price");
  const elVariants = document.getElementById("ks-qa-variants");
  const elAdd = document.getElementById("ks-qa-add");
  const elDetails = document.getElementById("ks-qa-details");
  const elMsg = document.getElementById("ks-qa-msg");

  let current = { product: null, variantId: null, productUrl: null };

  // ===============================
  // Helpers
  // ===============================
  function money(cents, currency = "EUR") {
    try {
      return new Intl.NumberFormat("de-DE", { style: "currency", currency }).format((cents || 0) / 100);
    } catch {
      return ((cents || 0) / 100).toFixed(2) + " €";
    }
  }

  function showMsg(text) {
    if (!elMsg) return;
    elMsg.hidden = false;
    elMsg.textContent = text || "";
  }

  function clearMsg() {
    if (!elMsg) return;
    elMsg.hidden = true;
    elMsg.textContent = "";
  }

  function esc(s) {
    return String(s || "").replace(/[&<>"']/g, (m) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
    }[m]));
  }

  function redirectToNotifyContact({ email = "", product = "", variant = "", variantId = "", url = "" }) {
    const qs = new URLSearchParams();
    qs.set("ks_notify", "1");
    if (email) qs.set("email", email);
    qs.set("product", product || "");
    qs.set("variant", variant || "");
    qs.set("variant_id", variantId ? String(variantId) : "");
    qs.set("url", url || "");
    window.location.href = "/pages/contact?" + qs.toString() + "#contact_form";
  }

  // ===============================
  // Notify UI (Modal → Redirect to Contact)
  // ===============================
  function showNotifyUI(variantId, variantTitle) {
    if (!elMsg) return;

    const productTitle = current.product?.title || "";

    elMsg.hidden = false;
    elMsg.innerHTML = `
      <div class="ks-qa__notify">
        <div class="ks-qa__notify-title">Ausverkauft – Benachrichtigen lassen</div>
        <div class="ks-qa__notify-meta">
          <span class="ks-qa__notify-prod">${esc(productTitle)}</span>
          ${variantTitle ? `<span class="ks-qa__notify-var">• ${esc(variantTitle)}</span>` : ``}
        </div>

        <div class="ks-qa__notify-row">
          <input id="ks-qa-notify-email" class="ks-qa__notify-input" type="email" placeholder="E-Mail Adresse" autocomplete="email">
          <button type="button" class="ks-qa__notify-btn" data-ks-qa-notify-send>Hier klicken!</button>
        </div>

        <div class="ks-qa__notify-hint">Du wirst zur Kontaktseite weitergeleitet – dort nur noch einmal „Erinnern lassen“ drücken.</div>

        <input type="hidden" id="ks-qa-notify-variant" value="${Number(variantId) || ""}">
      </div>
    `;
  }

  // ===============================
  // Modal open/close
  // ===============================
  function open() {
    root.hidden = false;
    document.documentElement.classList.add("ks-qa-open");
  }

  function close() {
    root.hidden = true;
    document.documentElement.classList.remove("ks-qa-open");

    clearMsg();
    if (elVariants) elVariants.innerHTML = "";
    if (elAdd) elAdd.disabled = true;

    current = { product: null, variantId: null, productUrl: null };
  }

  backdropCloseEls.forEach((el) => el.addEventListener("click", close));
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !root.hidden) close();
  });

  // ===============================
  // Cart add
  // ===============================
  async function addToCart(variantId) {
    if (!variantId) return;

    elAdd.disabled = true;
    showMsg("Wird hinzugefügt…");

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!res.ok) {
        showMsg("Konnte nicht hinzugefügt werden. Bitte erneut versuchen.");
        elAdd.disabled = false;
        return;
      }

      showMsg("✅ Im Warenkorb!");

      // Theme hooks
      document.dispatchEvent(new CustomEvent("ajaxProduct:added", { bubbles: true }));
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      document.dispatchEvent(new CustomEvent("theme:cart:refresh"));

      // Our event for drawer
      document.dispatchEvent(new CustomEvent("ks:cart:added", { detail: { variantId } }));

      window.setTimeout(() => {
        close();
        document.dispatchEvent(new CustomEvent("cart:open"));
      }, 350);

    } catch (err) {
      showMsg("Konnte nicht hinzugefügt werden. Bitte erneut versuchen.");
      elAdd.disabled = false;
    }
  }

  function setVariantById(variantId) {
    const product = current.product;
    if (!product) return;

    const id = Number(variantId);
    const v = product.variants.find((x) => x.id === id);
    if (!v) return;

    current.variantId = id;
    if (elPrice) elPrice.textContent = money(v.price, product.currency || "EUR");
    if (elAdd) elAdd.disabled = !v.available;

    // Wenn wieder verfügbar ausgewählt wurde, Notify-UI entfernen
    if (v.available && elMsg?.querySelector(".ks-qa__notify")) clearMsg();
  }

  function renderVariants(product) {
    if (!elVariants) return;

    const list = document.createElement("div");
    list.className = "ks-qa__vlist";

    product.variants.forEach((v) => {
      const row = document.createElement("label");
      row.className = "ks-qa__vrow" + (v.available ? "" : " is-disabled");
      row.setAttribute("data-variant-id", String(v.id));
      row.setAttribute("data-variant-title", v.title);

      row.innerHTML = `
        <input type="radio" name="ks-qa-variant" value="${v.id}" ${v.available ? "" : "disabled"}>
        <span class="ks-qa__vname">${esc(v.title)}</span>
        <span class="ks-qa__vprice">${money(v.price, product.currency || "EUR")}</span>
        ${v.available ? `` : `<span class="ks-qa__notify-pill">ERINNERN</span>`}
      `;

      list.appendChild(row);
    });

    const hint = document.createElement("div");
    hint.className = "ks-qa__hintline";
    hint.textContent = "Ausverkauft? Klick auf die Variante für eine Erinnerung.";

    elVariants.innerHTML = "";
    elVariants.appendChild(list);
    elVariants.appendChild(hint);

    const firstAvail = product.variants.find((v) => v.available);
    if (firstAvail) {
      const input = elVariants.querySelector(`input[value="${firstAvail.id}"]`);
      if (input) input.checked = true;
      current.variantId = firstAvail.id;
      elAdd.disabled = false;
      if (elPrice) elPrice.textContent = money(firstAvail.price, product.currency || "EUR");
      clearMsg();
    } else {
      // PREMIUM: kein Dead-End
      current.variantId = null;
      elAdd.disabled = true;
      showNotifyUI("", "");
    }
  }

  async function loadProductByUrl(productUrl) {
    const url = productUrl.endsWith("/") ? productUrl.slice(0, -1) : productUrl;
    const res = await fetch(url + ".js", { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error("product json failed");
    return await res.json();
  }

  async function openForProductUrl(productUrl, seededTitle, seededImageUrl) {
    try {
      current.productUrl = productUrl;

      if (elName) elName.textContent = seededTitle || "";
      if (elDetails) elDetails.href = productUrl;

      if (elImg) {
        elImg.innerHTML = seededImageUrl
          ? `<img src="${seededImageUrl}" alt="${esc(seededTitle || "")}">`
          : "";
      }

      if (elPrice) elPrice.textContent = "";
      if (elAdd) elAdd.disabled = true;

      showMsg("Lade Optionen…");
      open();

      const product = await loadProductByUrl(productUrl);
      current.product = product;

      if (elName) elName.textContent = product.title;
      if (elDetails) elDetails.href = productUrl;

      if (elImg && !seededImageUrl && product.featured_image) {
        elImg.innerHTML = `<img src="${product.featured_image}" alt="${esc(product.title)}">`;
      }

      renderVariants(product);
    } catch (err) {
      if (elAdd) elAdd.disabled = true;
      showMsg("Konnte Optionen nicht laden. Bitte Produktseite öffnen.");
    }
  }

  function openForHandle(handle, seededTitle, seededImageUrl) {
    if (!handle) return;
    return openForProductUrl(`/products/${handle}`, seededTitle, seededImageUrl);
  }

  // ===============================
  // UI Events
  // ===============================

  // Add to cart
  elAdd?.addEventListener("click", () => {
    if (!current.variantId) return;
    addToCart(current.variantId);
  });

  // Variant change
  elVariants?.addEventListener("change", (e) => {
    const input = e.target.closest('input[name="ks-qa-variant"]');
    if (!input) return;
    setVariantById(input.value);
  });

  // Open quick add (ONLY new standard)
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".ks-qa-trigger");
    if (!btn) return;

    e.preventDefault();

    const handle = btn.getAttribute("data-product-handle");
    if (!handle) return;

    const title = btn.getAttribute("data-title") || "";
    const imageUrl = btn.getAttribute("data-image") || "";

    openForHandle(handle, title, imageUrl);
  });

  // ===============================
  // Notify in Modal + Notify on OOS Card
  // ===============================

  // Modal notify flow
  root.addEventListener("click", (e) => {
    const disabledRow = e.target.closest(".ks-qa__vrow.is-disabled");
    if (disabledRow) {
      const variantId = disabledRow.getAttribute("data-variant-id") || "";
      const variantTitle = disabledRow.getAttribute("data-variant-title") || "";

      // Remove current selection (if any)
      try {
        const checked = elVariants?.querySelector('input[name="ks-qa-variant"]:checked');
        if (checked) checked.checked = false;
      } catch (e) {}

      if (elAdd) elAdd.disabled = true;

      // Mark as active
      try {
        elVariants?.querySelectorAll(".ks-qa__vrow.ks-qa-oos-active")
          ?.forEach((n) => n.classList.remove("ks-qa-oos-active"));
        disabledRow.classList.add("ks-qa-oos-active");
      } catch (e) {}

      showNotifyUI(variantId, variantTitle);
      return;
    }

    const sendBtn = e.target.closest("[data-ks-qa-notify-send]");
    if (!sendBtn) return;

    const emailEl = root.querySelector("#ks-qa-notify-email");
    const vIdEl = root.querySelector("#ks-qa-notify-variant");

    const email = (emailEl?.value || "").replace(/\s+/g, "").trim();
    const variantId = Number(vIdEl?.value || 0);

    // Variant title from product JSON
    let variantTitle = "";
    const v = current.product?.variants?.find((x) => x.id === variantId);
    if (v) variantTitle = v.title;

    if (!email || !email.includes("@")) {
      emailEl?.focus();
      return;
    }

    sendBtn.disabled = true;
    sendBtn.textContent = "Weiter…";

    redirectToNotifyContact({
      email,
      product: current.product?.title || "",
      variant: variantTitle || "",
      variantId: variantId || "",
      url: current.productUrl || "",
    });
  });

  // OOS card notify button → contact (same query keys)
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".ks-notify-trigger, .ks-notify-btn");
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const title = btn.dataset.title || "";
    const handle = btn.dataset.productHandle || "";
    const url = handle
      ? window.location.origin + "/products/" + handle
      : window.location.href;

    redirectToNotifyContact({
      product: title,
      variant: "",
      variantId: "",
      url,
    });
  });

})();